import React, { useState } from "react";
import "../../../styles/pages/customer/konten.scss";
import Heading from "../../../component/Heading/Heading";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CommonButton from "../../../component/button/Button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { createTheme, ThemeProvider } from "@mui/material";
import KonenComponent from "./KonenComponent";
import DarlehenComponent from "./DarlehenComponent";
import GeneratePDF from "./pdf/Index";
import { t } from "i18next";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Konten = () => {
  const [value, setValue] = useState(0);
  const [selectedTabName, setSelectedTabName] = useState('Konten');
  const [konten, setKonten] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setSelectedTabName('Konten');
      setKonten([])
    } else if (newValue === 1) {
      setSelectedTabName('Darlehen');
      setKonten([])
    }
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        xxl: 2150,
        xxxl: 4100
      },
    },
  });

  return (
    <div className="konten-wrapper">
      <div className="flex items-center justify-between">
        <Heading text={t('konten_tabname')} className="heading" />
      </div>
      <div >
        <ThemeProvider theme={theme}>
          <Box sx={{ width: '100%' }}>
            <Box className="konten-tabs-btn" sx={{
              display: {
                xs: 'block',
                md: 'flex',
              }, justifyContent: "space-between", alignItems: "center", padding: "30px 0 15px 0"
            }}>
              <Tabs
                value={value}
                className="konten-tabs"
                onChange={handleTabChange}
                aria-label="basic tabs example"
                sx={{
                  '& .MuiTabs-flexContainer': {
                    justifyContent: 'center',
                    display: {
                      xs: "block",
                      md: "inline-block"
                    },
                    border: "1px solid #E3E3E3",
                    borderRadius: "10px",
                  },
                  '& .Mui-selected': {
                    color: '#fff !important',
                    borderRadius: "10px",
                    fontWeight: 'bold',
                    background: "linear-gradient(to bottom, #000000 0%, #40330D 100%)",
                  },
                  '& .MuiTabs-indicator': {
                    display: 'none',
                  },
                }}
              >
                <Tab
                  label={t('konten_tabname')}
                  className="konten-btn"
                  {...a11yProps(0)}
                  sx={{
                    minHeight: '40.5px',
                    height: '40.5px',
                    width: "50%"
                  }}
                />
                <Tab
                  label={t('dashboard_darlehen')}
                  className="konten-btn"
                  {...a11yProps(1)}
                  sx={{
                    minHeight: '40.5px',
                    height: '40.5px',
                    width: "50%"
                  }}
                />
              </Tabs>
              <div className="konten_add-btn">
                {
                  konten?.length > 0 && <GeneratePDF
                    data={konten}
                    orientation={selectedTabName?.toLowerCase() === 'konten' ? 'portrait' : 'landscape'}
                  />
                }
                <CommonButton
                  text={`${t('stammdaten_add')} ${selectedTabName?.toLowerCase() === 'konten' ? t('module_konten') : t('dashboard_darlehen')}`}
                  color="#fff"
                  className="add-konten-btn"
                  onClick={() => {
                    setIsModalOpen(true)
                  }}
                  icon={<AddCircleOutlineIcon className="add-konten-icon" />
                  }
                />
              </div>
            </Box>
            <div >
              <CustomTabPanel value={value} index={0}>
                <Box sx={{ padding: 0 }}>
                  <KonenComponent konten={konten} setKonten={setKonten} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Box sx={{ padding: 0 }}>
                  <DarlehenComponent konten={konten} setKonten={setKonten} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                </Box>
              </CustomTabPanel>
            </div>
          </Box>
        </ThemeProvider>
      </div >
    </div >
  );
};

export default Konten;
